import React from 'react';
import { Link } from 'react-router-dom';
import './pages.css';

const NotFound: React.FC = () => (
    <section className="not-found">
        <div className="container">
            <span className="kicker enter" style={{ ['--i' as string]: 0 }}>404</span>
            <h1 className="enter" style={{ ['--i' as string]: 1 }}>
                This page moved or never existed
            </h1>
            <p className="lede enter" style={{ ['--i' as string]: 2 }}>
                The Kifayti site was recently restructured. Try the product suite, our IT services
                or head back to the homepage.
            </p>
            <div className="btn-row not-found__actions enter" style={{ ['--i' as string]: 3 }}>
                <Link className="btn btn--primary btn--lg" to="/">
                    Back to home
                </Link>
                <Link className="btn btn--ghost-dark btn--lg" to="/products">
                    Product suite
                </Link>
            </div>
        </div>
    </section>
);

export default NotFound;
